import React from 'react';
import clsx from 'clsx';

// Material
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
// Styles
import useStyles from './ProductListItem.style.js'

const ProductListItemLoader = () => {
    const classes = useStyles();
    return (<Card className={classes.root}>
        <div className={clsx('__loading', classes.cover)} />
        <div className={classes.details}>
            <CardContent className={classes.content}>
                <div className={'sub-heading-1__loading'}></div>
                <div className={'sub-heading-2__loading'}></div>
                <div className={'sub-heading-2__loading'}></div>
            </CardContent>
            <CardActions className={classes.bottomContent}>
                <div className={'sub-heading-1__loading'}></div>
            </CardActions>
        </div>
    </Card>)
};

export default ProductListItemLoader;